module.exports = __webpack_public_path__ + "static/logo-7b195c59c2ee60949865e99c15408999.png";